// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attaches__I2nlS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.attachmentsLabel__j8igp {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  padding-right: 17px;
}

.attachesBlock__DfKVz {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border: 1px dashed var(--buttons-surface);
  cursor: pointer;
}

.attachesLink__gC_LM {
  font-size: 14px;
  line-height: 12px;
  color: var(--buttons-surface);
  margin-left: 7px;
  margin-bottom: 4px;
  margin-top: 10px;
}

.uploadIcon__dolKG {
  stroke: --buttons-surface;
}

.attachesFiles__nI_JB {
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-top: 0;
  width: 100%;
  max-height: 115px;
  margin-top: 10px;
}

.scrollingBlock__fmySa {
  overflow-y: auto;
}
.scrollingBlock__fmySa::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.scrollingBlock__fmySa::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.scrollingBlock__fmySa::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.scrollingBlock__fmySa::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.attachBtnRight__PHTdC {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.uploadIconRight__zl81N {
  width: 15px;
  stroke: var(--buttons-surface);
}

.attachesLinkRight___VwSw {
  margin-top: 0;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CompletionReportModal/components/AttachmentsField/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,yBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;AA7BE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA+BJ;AA5BE;EACE,+BAAA;EACA,kBAAA;AA8BJ;AA3BE;EACE,8BAAA;EACA,kBAAA;AA6BJ;AA1BE;EACE,gBAAA;EACA,kBAAA;AA4BJ;;AA6DA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,8BAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,kBAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.attaches {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.attachmentsLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  padding-right: 17px;\n}\n\n.attachesBlock {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n  border: 1px dashed var(--buttons-surface);\n  cursor: pointer;\n}\n\n.attachesLink {\n  font-size: 14px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  margin-left: 7px;\n  margin-bottom: 4px;\n  margin-top: 10px;\n}\n\n.uploadIcon {\n  stroke: (--buttons-surface);\n}\n\n.attachesFiles {\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  margin-top: 0;\n  width: 100%;\n  max-height: 115px;\n  margin-top: 10px;\n}\n\n.scrollingBlock {\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.attachBtnRight {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.uploadIconRight {\n  width: 15px;\n  stroke: var(--buttons-surface);\n}\n\n.attachesLinkRight {\n  margin-top: 0;\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attaches": `attaches__I2nlS`,
	"attachmentsLabel": `attachmentsLabel__j8igp`,
	"attachesBlock": `attachesBlock__DfKVz`,
	"attachesLink": `attachesLink__gC_LM`,
	"uploadIcon": `uploadIcon__dolKG`,
	"attachesFiles": `attachesFiles__nI_JB`,
	"scrollingBlock": `scrollingBlock__fmySa`,
	"attachBtnRight": `attachBtnRight__PHTdC`,
	"uploadIconRight": `uploadIconRight__zl81N`,
	"attachesLinkRight": `attachesLinkRight___VwSw`
};
module.exports = ___CSS_LOADER_EXPORT___;
